import Api from "@/service/Api";

class DataAnalyticsService {
    getAllUsers = async () => {
        return await Api().get(`user-permissions-all-users`)
    }

    getAllTags = async () => {
        return await Api().get(`user-permissions-tag`)
    }
    getAllUsersTags = async (params) => {
        return await Api().get(`user-permissions-users-tags`, {
            params: params
        })
    }
    putUsersTags = async (data) => {
        return await Api().put(`user-permissions-users-tags`, {userIds: data.userIds, tagIds: data.tagIds, editTagType: data.editTagType})
    }
    postNewTag = async (tagName, tagPermissions) => {
        return await Api().post(`user-permissions-tag`, {tagName: tagName, permissions: tagPermissions})
    }

    putTag = async (editTagData) => {
        return await Api().put(`user-permissions-tag`, {tagId: editTagData.tagId, newPermissions: editTagData.permissions})
    }

    deleteTag = async (deleteTagsData) => {
        return await Api().delete(`user-permissions-tag`, {params: {deleteTagsData}})
    }
}

export default new DataAnalyticsService()